import { Empty } from 'antd';
import { isEmpty, omitBy } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui';

type EmptyStateProps = {
  loading?: boolean;
  emptyText?: string;
  filteredInfo?: any;
  onClearSortAndFilter?: () => void;
};

export const EmptyState: React.FunctionComponent<EmptyStateProps> = ({
  loading = false,
  emptyText: emptyTextProp = undefined,
  filteredInfo = undefined,
  onClearSortAndFilter = () => {},
}) => {
  const { t } = useTranslation();
  const emptyText = !isEmpty(omitBy(filteredInfo, isEmpty)) ? (
    <Button type="primary" onClick={onClearSortAndFilter}>
      {t('table.clearFilters', 'Clear filters')}
    </Button>
  ) : (
    emptyTextProp
  );

  return (
    <Empty
      description={loading ? t('table.loading', 'Loading...') : undefined}
      image={Empty.PRESENTED_IMAGE_SIMPLE}
    >
      {loading || emptyText}
    </Empty>
  );
};
